import axiosInstance from '@/core/api'
import {
	GetGameListRequest,
	GetGameListResponse,
	UpdateGameRequest,
	UpdateGameResponse,
	GameSyncResponse,
	UpdateGameProviderRequest,
	UpdateGameProviderResponse,
	UpdateGameTypeResponse,
	UpdateGameTypeRequest,
	GetGameTypeResponse,
	GetGameProviderListRequest,
	UpdateGameTypeProviderRequest,
	UpdateGameTypeProviderResponse,
	GameProviderWithBannerListResponse,
	GameProviderListResponse,
	BatchUpdateProviderPresetRequest,
	BatchUpdateProviderPresetResponse,
	BatchUpdateGamePresetRequest,
	BatchUpdateGamePresetResponse,
} from '../../type'
import {
	GetUploadlFileUrlRequest,
	GetUploadFileUrlResponse,
} from '@/modules/operator/type'

export const getGameList = async (
	payload: GetGameListRequest,
): Promise<GetGameListResponse> => {
	const response = await axiosInstance.get<GetGameListResponse>(
		'/admin/game/list',
		{
			params: payload,
		},
	)
	return response.data
}

export const updateGame = async (
	payload: UpdateGameRequest,
	id: string,
): Promise<UpdateGameResponse> => {
	const response = await axiosInstance.patch<UpdateGameResponse>(
		`/admin/game/update/${id}`,
		payload,
	)
	return response.data
}

export const syncGames = async (): Promise<GameSyncResponse> => {
	const response =
		await axiosInstance.post<GameSyncResponse>('/admin/game/sync')
	return response.data
}

export const getGameProviderGameTypeList = async (
	payload: GetGameProviderListRequest,
): Promise<GameProviderWithBannerListResponse> => {
	const response = await axiosInstance.get<GameProviderWithBannerListResponse>(
		'/admin/game/providers-by-game-type',
		{
			params: payload,
		},
	)
	return response.data
}

export const getGameProviderList = async (
	payload: GetGameProviderListRequest,
): Promise<GameProviderListResponse> => {
	const response = await axiosInstance.get<GameProviderListResponse>(
		'/admin/game/provider/list',
		{
			params: payload,
		},
	)
	return response.data
}

export const updateGameProvider = async (
	payload: UpdateGameProviderRequest,
	id: string,
): Promise<UpdateGameProviderResponse> => {
	const response = await axiosInstance.patch<UpdateGameProviderResponse>(
		`/admin/game/provider/${id}`,
		payload,
	)
	return response.data
}

export const getGameTypeList = async (): Promise<GetGameTypeResponse> => {
	const response = await axiosInstance.get<GetGameTypeResponse>(
		'/admin/game/type/list',
	)
	return response.data
}

export const updateGameType = async (
	payload: UpdateGameTypeRequest,
	id: string,
): Promise<UpdateGameTypeResponse> => {
	const response = await axiosInstance.patch<UpdateGameTypeResponse>(
		`/admin/game/type/update/${id}`,
		payload,
	)
	return response.data
}

export const updateGameTypeProvider = async (
	payload: UpdateGameTypeProviderRequest,
	id: string,
): Promise<UpdateGameTypeProviderResponse> => {
	const response = await axiosInstance.patch<UpdateGameTypeProviderResponse>(
		`/admin/game/provider-game-type/update/${id}`,
		payload,
	)
	return response.data
}

export const getGameImageUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-game-image-upload-file-url`,
		request,
	)
	return response.data
}

export const getProviderBannerUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-provider-banner-upload-file-url`,
		request,
	)
	return response.data
}

export const getProviderLogoUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-provider-logo-upload-file-url`,
		request,
	)
	return response.data
}

export const batchUpdateProviderPreset = async (
	payload: BatchUpdateProviderPresetRequest,
): Promise<BatchUpdateProviderPresetResponse> => {
	const response = await axiosInstance.post<BatchUpdateProviderPresetResponse>(
		'/admin/game/provider/batch-set-preset',
		payload,
	)
	return response.data
}

export const batchUpdateGamePreset = async (
	payload: BatchUpdateGamePresetRequest,
): Promise<BatchUpdateGamePresetResponse> => {
	const response = await axiosInstance.post<BatchUpdateGamePresetResponse>(
		'/admin/game/batch-set-preset',
		payload,
	)
	return response.data
}
